import React from "react";
import { StarIcon, BadgeCheckIcon } from "lucide-react";
import { testimonials } from "../data/content";
import { CtaButton } from "./CtaButton";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-270" data-mp="1n00ra3zw93vo">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-271" data-mp="1r141a9v9g5oz" data-mpi={i} />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-272" data-mp="1d47f4lq37cef">
      <div className="mx-auto max-w-5xl" data-id="element-273" data-mp="1i1qqndvehb2o">
        <div className="text-center" data-id="element-274" data-mp="1hyl5g9pw6tc8">
          <h2 className="font-serif text-[30px] font-black leading-tight text-ink sm:text-5xl" data-id="element-275" data-mp="141y29p7cj6xv">What other men are saying</h2>
          <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-cream px-4 py-2" data-id="element-276" data-mp="1839wy952uicx">
            <Stars data-id="element-277" data-mp="2yfpcaptl7stu" />
            <span className="text-sm font-bold text-ink" data-id="element-278" data-mp="2yd336lr1t59i">4.9/5 customer rating</span>
          </div>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-279" data-mp="32eg90vu558gf">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-cream p-6" data-id="element-280" data-mp="2uz837s73n19q">
              <div className="flex items-center gap-3" data-id="element-281" data-mp="2q0ewcimbi8ij">
                <img src={t.image} alt={t.name} className="h-14 w-14 rounded-full object-cover ring-2 ring-gold" loading="lazy" data-id="element-282" data-mp="34qcdieltxxy8" />
                <figcaption data-id="element-283" data-mp="2zt2rl8xng4f5">
                  <p className="font-bold text-ink" data-id="element-284" data-mp="2c2qdfgbt9bg4">{t.name}</p>
                  <p className="text-sm text-ink/60" data-id="element-285" data-mp="2c2ypx740ueqs">{t.location}</p>
                </figcaption>
              </div>
              <div className="mt-4" data-id="element-286" data-mp="275q8j8qp6eql">
                <Stars data-id="element-287" data-mp="2m1flyihthjjp" />
              </div>
              <blockquote className="mt-3 text-[16px] leading-relaxed text-ink/85" data-id="element-288" data-mp="2m27grr3lbd8x">“{t.quote}”</blockquote>
              <p className="mt-auto flex items-center gap-1.5 pt-5 text-xs font-semibold text-success" data-id="element-289" data-mp="2h0i5qbgdazku">
                <BadgeCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-290" data-mp="1crsb2rug0mg" />
                Verified customer
              </p>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-291" data-mp="3dz8wm2wvrzz">
          <CtaButton label="I want to build this skill too" data-id="element-292" data-mp="3h4y01bjitvp" />
        </div>
      </div>
    </section>;
}